import { cva } from 'class-variance-authority';

import { cn } from '@/shared/utils/cn';

const borderGradientVariants = cva('bg-gradient-to-br p-px h-full', {
  variants: {
    variant: {
      default: 'from-white/10 to-white/50',
    },
  },
});

interface BorderGradientProps {
  variant?: 'default';
  children: React.ReactNode;
  radius?:
    | '2xs'
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | 'full'
    | 'none';
  className?: string;
}

export const BorderGradient = ({
  variant = 'default',
  children,
  radius = 'xs',
  className,
}: BorderGradientProps) => {
  return (
    <div
      className={cn(borderGradientVariants({ variant }), `rounded-${radius}`)}
    >
      <div className={cn('h-full w-full rounded-xs', className)}>
        {children}
      </div>
    </div>
  );
};
